import React, { useEffect, useState } from "react";
import { Card, CardBody } from "reactstrap";
import { getAgreement } from "../../api";
import { getClientWithIdReq } from "../../service/clientService";
import { getTaxesReq } from "../../service/itemService";
import getPaymentTerm from "../../utility/getPaymentTerm";
import AgreementPdfComponent from "../Client/AgreementPdfComponent";

const AgreementCard = ({ clientId }) => {
  const [agreementData, setAgreementData] = useState({
    AgreementNumber: "",
    validity: "",
    paymentTerms: "",
  });

  const [displayTableData, setDisplayTableData] = useState([]);
  const [clientData, setClientData] = useState({});
  const [loading, setLoading] = useState(false);

  const getMonthName = (monthIndex) => {
    const months = [
      "January", "February", "March", "April", "May", "June",
      "July", "August", "September", "October", "November", "December"
    ];
    return months[monthIndex];
  };

  const getOrdinal = (day) => {
    if (day > 3 && day < 21) return `${day}th`;
    switch (day % 10) {
      case 1: return `${day}st`;
      case 2: return `${day}nd`;
      case 3: return `${day}rd`;
      default: return `${day}th`;
    }
  };

  const formatDate = (dateString) => {
    if (!dateString) return "Day/MM/YYYY";
    const date = new Date(dateString);
    return `${getOrdinal(date.getDate())} ${getMonthName(date.getMonth())} ${date.getFullYear()}`;
  };

  const fetchAgreementData = async () => {
    try {
      setLoading(true);

      const res = await getAgreement({ clientId });

      const taxRes = await getTaxesReq();
      const taxes = taxRes?.payload?.taxes || [];

      const clientRes = await getClientWithIdReq({ _id: clientId });
      setClientData(clientRes.payload?.client || {});

      const items = res?.payload?.items || [];

      const mapped = items.flatMap((item) =>
        item.variants.map((variant) => {
          const taxName = taxes.find(
            (t) => t._id === item.item.taxes[0]
          )?.name;

          return {
            id: variant.variant._id,
            title: item.item.title,
            sellingPrice: variant.price,
            attributes: variant.variant.attributes,
            tax: taxName,
            unit: item.item.itemUnit,
            type: item.item.itemType,
          };
        })
      );

      setDisplayTableData(mapped);

      setAgreementData({
        AgreementNumber: res.payload._id,
        validity: res.payload.validity,
        paymentTerms: res.payload.paymentTerms,
      });

    } catch (error) {
      console.error("Agreement Error:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (clientId) {
      fetchAgreementData();
    }
  }, [clientId]);

  if (loading) {
    return <div>Loading agreement...</div>;
  }

  return (
    <Card className="agreement-card">
      <CardBody className="agreement-body">
        <div>
          <h6 className="font-size-12 mb-0">Payment Terms</h6>
          <h2 className="mb-0 font-size-20 text-black">
            {getPaymentTerm(agreementData.paymentTerms)}
          </h2>
        </div>

        <div>
          <h6 className="font-size-12 mb-0">Valid Until</h6>
          <h2 className="mb-0 font-size-20 text-black">
            {formatDate(agreementData.validity)}
          </h2>
        </div>

        <AgreementPdfComponent
          data={{ displayTableData, ...clientData, ...agreementData }}
        />
      </CardBody>
    </Card>
  );
};

export default AgreementCard;